<template>
  <div class="primary-theme dark-theme c-fluid" id="action">
    <div class="row">
      <div class="col-sm-12 col-lg-8 px-0 row">
        <div class="col-3 title-line yellow my-auto"></div>
        <div class="col-4 title-text my-auto text-center">T A K E &nbsp; A C T I O N</div>
        <div class="col-5 title-line yellow my-auto"></div>
      </div>
    </div>
    <div class="section-content">
      <h1 class="quote">use your words, time or money to change the world</h1>
      <div class="row mx-auto">
        <div
          class="col-xs-12 col-sm-6 col-md-4 mb-5 text-center"
          v-for="(m, index) in list"
          :key="index"
        >
          <div>
            <svgicon :icon="m.icon" color="#ffc001" class="icon"></svgicon>
          </div>
          <div class="details">
            <h2 class="my-3 fw-6 icon-title">{{m.title}}</h2>
            <p class="my-3">{{m.description}}</p>
          </div>
          <button
            @click="toggleModal(m.modalId)"
            :data-target="m.modalId"
            data-toggle="modal"
            class="btn-main text-white py-3 px-5 my-3"
            v-if="m.moreText"
          >{{m.btn}} &nbsp; {{m.moreText}}</button>
          <button
            @click="toggleModal(m.modalId)"
            :data-target="m.modalId"
            data-toggle="modal"
            class="btn-main text-white py-3 px-5 my-3"
            v-else
          >{{m.btn}}</button>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" id="shareModal">
      <div class="modal-dialog light-theme" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Spread Love with Words</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body px-4 pt-0">
            <div class="my-4">
              <input id="shareWordsName" class="info" />
              <p class="text-right info-label mt-2">F U L L &nbsp; N A M E</p>
            </div>
            <div class="my-4">
              <input id="shareWordsEmail" class="info" />
              <p class="text-right info-label mt-2">E M A I L</p>
            </div>
            <div class="my-4">
              <textarea id="shareWordsMessage" class="info" rows="6"></textarea>
              <p class="text-right info-label mt-2">M E S S A G E</p>
            </div>
            <small class="d-none delivered s-delivered mb-3">Message sent!</small>
            <button
              class="btn-main text-white py-3 px-5 my-3"
              @click="sendShareWordsMessage()"
            >S U B M I T</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" id="donateModal">
      <div class="modal-dialog light-theme" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Every contribution counts</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body px-4 pt-0">
            <div class="my-4">
              <input class="info" id="donateName" />
              <p class="text-right info-label mt-2">F U L L &nbsp; N A M E</p>
            </div>
            <div class="my-4">
              <input class="info" id="donateEmail" />
              <p class="text-right info-label mt-2">E M A I L</p>
            </div>
            <div class="my-4 row">
              <div class="col-sm-12 col-md-6">
                <input class="info" id="donatePhoneNumber" />
                <p class="text-right info-label mt-2">P H O N E &nbsp; N U M B E R</p>
              </div>
              <div class="col-sm-12 col-md-6">
                <select id="donateArea">
                  <option>General</option>
                  <option>Disabled</option>
                  <option>Orphanage</option>
                  <option>Education</option>
                  <option>Welfare / Community</option>
                  <option>Hospice</option>
                </select>
                <p class="text-right info-label mt-2">A R E A &nbsp; O F &nbsp; I N T E R E S T</p>
              </div>
            </div>

            <div class="my-4">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">₦</span>
                </div>
                <input id="donateAmount" class="form-control" v-on:keypress="isNumberKey($event)" />
                <div class="input-group-append">
                  <span class="input-group-text">.00</span>
                </div>
              </div>
              <p class="text-right info-label mt-2">A M O U N T</p>
            </div>

            <div>
              <small>
                For more on international transfer please
                <span
                  class="pointer contact"
                  @click="scrollToContact()"
                >contact us</span>
              </small>
            </div>
            <small class="d-none delivered d-delivered mb-3">Message sent!</small>
            <button class="btn-main text-white py-3 px-5 my-3" @click="sendDonateInfo()">N E X T</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" id="joinModal">
      <div class="modal-dialog light-theme" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Join us to lift others. Inspire. Act!</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body px-4 pt-0">
            <div class="my-4">
              <input id="joinName" class="info" />
              <p class="text-right info-label mt-2">F U L L &nbsp; N A M E</p>
            </div>
            <div class="my-4">
              <input id="joinEmail" class="info" />
              <p class="text-right info-label mt-2">E M A I L</p>
            </div>
            <div class="my-4 row">
              <div class="col-sm-12 col-md-6">
                <input id="joinPhoneNumber" class="info" />
                <p class="text-right info-label mt-2">P H O N E &nbsp; N U M B E R</p>
              </div>
              <div class="col-sm-12 col-md-6">
                <select id="joingArea">
                  <option value="General">General</option>
                  <option value="Disabled">Visually Impaired</option>
                  <option value="Orphanage">Orphanage</option>
                  <option value="Education/Training">Education/Training</option>
                  <option value="Welfare/Community">Welfare/Community</option>
                  <option value="Hospice">Hospice</option>
                  <option value="Research">Research</option>
                  <option value="Arts">Arts</option>
                  <option value="Event Planning">Event Planning</option>
                  <option value="IT">IT</option>
                </select>
                <p class="text-right info-label mt-2">A R E A &nbsp; O F &nbsp; I N T E R E S T</p>
              </div>
            </div>
            <div class="my-4 row">
              <div class="col-6">
                <select id="joinGender">
                  <option value="Female">Female</option>
                  <option value="Male">Male</option>
                </select>
                <p class="text-right info-label mt-2">G E N D E R</p>
              </div>
              <div class="col-6">
                <select id="joinAvailable">
                  <option value="Flexible">Flexible</option>
                  <option value="Weekdays">Weekdays</option>
                  <option value="Weekends">Weekends</option>
                  <option value="Mornings">Mornings</option>
                  <option value="Evening">Evening</option>
                </select>
                <p class="text-right info-label mt-2">A V A I L A B I L I T Y</p>
              </div>
            </div>
            <div class="my-4">
              <textarea class="info" rows="2" id="joinAddress"></textarea>
              <p class="text-right info-label mt-2">A D D R E S S</p>
            </div>
            <div class="my-4">
              <input class="info" id="joinHeard" />
              <p
                class="text-right info-label mt-2"
              >H O W &nbsp; D I D &nbsp; Y O U &nbsp; H E A R &nbsp; A B O U T &nbsp; U S?</p>
            </div>
            <small class="d-none delivered j-delivered mb-3">Message sent!</small>
            <button class="btn-main text-white py-3 px-5 my-3" @click="sendJoinUsInfo()">S U B M I T</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./../compiled-icons/share";
import "./../compiled-icons/give";
import "./../compiled-icons/network";
import data from "./../data/data";

function payWithPaystack(customerEmail, amount, phoneNumber) {
  var handler = PaystackPop.setup({
    key: "pk_live_5f88614d63392fc9d00c4006e9e57180ba57c74b",
    email: customerEmail,
    amount: amount + "00", // 00 is for kobo
    currency: "NGN",
    metadata: {
      custom_fields: [
        {
          display_name: "Mobile Number",
          variable_name: "mobile_number",
          value: phoneNumber
        }
      ]
    },
    callback: function(response) {
      console.log("success. transaction ref is " + response.reference);
    },
    onClose: function() {
      console.log("window closed");
    }
  });
  handler.openIframe();
}
export default {
  name: "Mission",
  data() {
    return {
      list: data.contribute
    };
  },
  methods: {
    sendShareWordsMessage() {
      startSpinner("#shareModal");
      $.ajax({
        type: "POST",
        url: "/shareWords",
        contentType: "application/json",
        data: JSON.stringify({
          subject: "FROM SHARE WORDS",
          name: $("#shareWordsName")
            .val()
            .trim(),
          email: $("#shareWordsEmail")
            .val()
            .trim(),
          message: $("#shareWordsMessage")
            .val()
            .trim()
        })
      }).always(function(response) {
        if (response.status) {
          $("#shareWordsName").val("");
          $("#shareWordsEmail").val("");
          $("#shareWordsMessage").val("");
          $("#shareModal").modal("hide");
          $(".s-delivered").addClass("d-none");
        } else {
          $(".s-delivered").html(
            '<span class="text-danger">*</span> ' + response.message
          );
          $(".s-delivered").removeClass("d-none");
        }
        console.log("I GOT HERE");
        console.log(response);
        stopSpinner();
      });
    },
    sendJoinUsInfo() {
      startSpinner("#joinModal");
      $.ajax({
        type: "POST",
        url: "/joinUs",
        contentType: "application/json",
        data: JSON.stringify({
          subject: "FROM JOIN US",
          name: $("#joinName")
            .val()
            .trim(),
          email: $("#joinEmail")
            .val()
            .trim(),
          phoneNumber: $("#joinPhoneNumber")
            .val()
            .trim(),
          areaOfInterest: $("#joingArea").val(),
          gender: $("#joinGender").val(),
          availability: $("#joinAvailable").val(),
          address: $("#joinAddress")
            .val()
            .trim(),
          heard: $("#joinHeard")
            .val()
            .trim()
        })
      }).always(function(response) {
        if (response.status) {
          $("#joinName").val("");
          $("#joinEmail").val("");
          $("#joinPhoneNumber").val("");
          $("#joinHeard").val("");
          $("#joinAddress").val("");
          $("#joinModal").modal("hide");
          $(".j-delivered").addClass("d-none");
        } else {
          $(".j-delivered").html(
            '<span class="text-danger">*</span> ' + response.message
          );
          $(".j-delivered").removeClass("d-none");
        }
        console.log("I GOT HERE");
        console.log(response);
        stopSpinner();
      });
    },
    sendDonateInfo() {
      startSpinner("#donateModal");
      $.ajax({
        type: "POST",
        url: "/donate",
        contentType: "application/json",
        data: JSON.stringify({
          subject: "FROM DONATION FORM (Transaction Initiation)",
          name: $("#donateName")
            .val()
            .trim(),
          email: $("#donateEmail")
            .val()
            .trim(),
          phoneNumber: $("#donatePhoneNumber")
            .val()
            .trim(),
          areaOfInterest: $("#donateArea").val(),
          amount: $("#donateAmount").val()
        })
      }).always(function(response) {
        console.log("I GOT HERE");
        console.log(response);

        if (response.status) {
          $("#donateName").val("");
          $("#donateEmail").val("");
          $("#donatePhoneNumber").val("");
          $("#donateAmount").val("");
          $("#donateModal").modal("hide");
          $(".d-delivered").addClass("d-none");

          payWithPaystack(
            response.email,
            response.amount,
            response.phoneNumber
          );
        } else {
          $(".d-delivered").html(
            '<span class="text-danger">*</span> ' + response.message
          );
          $(".d-delivered").removeClass("d-none");
        }

        stopSpinner();
      });
    },
    isNumberKey(event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57))
        event.preventDefault();

      return true;
    },
    scrollToContact() {
      $("#donateModal").modal("hide");
      $("html, body").animate(
        {
          scrollTop: $("#contact").offset().top
        },
        0
      );
    },
    toggleModal(modalId) {
      $("#myModal")
        .on("show", function() {
          $("body").addClass("modal-open");
        })
        .on("hidden", function() {
          $("body").removeClass("modal-open");
        });
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .icon {
    width: 3rem;
  }
  .icon-title {
    font-size: 1.5rem;
  }
}

@media screen and (min-width: 801px) {
  .icon {
    width: 4rem;
  }
}

.info {
  border-bottom: 1px solid;
}
select {
  width: 100%;
}
.delivered {
  display: block;
}
@media screen and (min-width: 1050px) {
  .details {
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contribute.vue